import { Button, Container, Stack, TextField, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { FormEvent, useState, useCallback } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import { supabaseClient } from "src/supabase/supabaseClient";
import HolaVidaLogo from "src/assets/icons/HolaVidaLogo";
import { Link } from "react-router-dom";

function isString(data: FormDataEntryValue | null): data is string {
  return data !== null && typeof data === "string";
}
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const handleClickShowPassword = useCallback(
    () => setShowPassword((show) => !show),
    [],
  );
  const handleMouseDownPassword = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    [],
  );
  const handleMouseUpPassword = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    [],
  );

  const handlePassword = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setPassword(event.target.value);
    },
    [],
  );

  const onSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      const formData = new FormData(event.target as HTMLFormElement);

      const email = formData.get("email");

      if (isString(email) && password.length > 0) {
        supabaseClient.auth.signInWithPassword({ email, password });
      }
    },
    [password],
  );

  return (
    <Container maxWidth="xs" style={{ height: "100%" }}>
      <Stack alignItems="center" justifyContent="center" height="100%">
        <Stack
          padding="96px 32px"
          width="400px"
          alignItems="center"
          justifyContent="center"
          gap="32px"
          boxShadow={10}
          style={{ background: "white", borderRadius: "16px" }}
        >
          <HolaVidaLogo />
          <Typography variant="h4" alignSelf="baseline">
            Portal Login
          </Typography>

          <Stack
            width="100%"
            justifyContent="center"
            gap="16px"
            component="form"
            onSubmit={onSubmit}
          >
            <Stack gap="8px">
              <Typography>Email</Typography>
              <TextField
                type="email"
                placeholder="Email"
                required
                fullWidth
                name="email"
              />
            </Stack>
            <Stack gap="8px">
              <Typography>Password</Typography>
              <OutlinedInput
                onChange={handlePassword}
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? "hide the password"
                          : "display the password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Stack>
            <Link to="/reset-password" style={{ textAlign: "center" }}>
              Forgot password?
            </Link>
            <Button type="submit">Log in</Button>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default Login;
